<script setup>
import { CheckCircleIcon } from "@heroicons/vue/20/solid"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const benefits = [
  t("home.cta.benefit.benefit1"),
  t("home.cta.benefit.benefit2"),
  t("home.cta.benefit.benefit3"),
  t("home.cta.benefit.benefit4"),
  t("home.cta.benefit.benefit5"),
  t("home.cta.benefit.benefit6"),
]
</script>

<template>
  <!-- CTA section -->
  <div class="relative isolate mt-28 sm:mt-16 pb-12" data-aos="zoom-y-out">
    <div class="mx-auto max-w-7xl sm:px-6 lg:px-8 py-15">
      <div
        class="mx-auto flex py-15 max-w-2xl flex-col gap-16 glass-effect-card px-6 py-16 ring-1 ring-white/10 sm:rounded-3xl sm:p-8 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-20 xl:gap-x-20 xl:px-20"
      >
        <img
          class="h-96 w-full flex-none rounded-2xl object-cover shadow-xl lg:aspect-square lg:h-auto lg:max-w-sm"
          src="https://images.ctfassets.net/1b6f0wuf6ave/4xB7N4dYLN79IwlEkbYXSs/f1d5127face9243df2b7e09d4b6f7fe0/features-home-element-04.jpg"
          alt=""
        />
        <div class="w-full flex-auto">
          <h2
            class="text-3xl font-bold tracking-tight text-gray-700 sm:text-4xl"
          >
            {{ $t("home.cta.title") }}
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            {{ $t("home.cta.subtitle") }}
          </p>
          <ul
            role="list"
            class="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base leading-7 text-gray-700 sm:grid-cols-2"
          >
            <li v-for="benefit in benefits" :key="benefit" class="flex gap-x-3">
              <CheckCircleIcon
                class="h-7 w-5 flex-none text-gray-800"
                aria-hidden="true"
              />
              {{ benefit }}
            </li>
          </ul>
          <div class="mt-10 flex items-center justify-left gap-x-6">
            <router-link
              :to="{ name: 'LeadFlow' }"
              class="rounded-md bg-gradient-to-r from-orange-500 to-yellow-400 px-3.5 py-2.5 text-base font-medium text-gray-200 shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >{{ $t("home.hero.discover-potential") }}
            </router-link>
            <router-link
              class="text-base font-medium text-gray-900 leading-6"
              :to="{ name: 'HelpHouseholder' }"
              >{{ $t("home.hero.learn-more")
              }}<span aria-hidden="true"> →</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
      aria-hidden="true"
    >
      <div
        class="aspect-[1318/752] w-[82.375rem] flex-none bg-gradient-to-r from-[#FDB777] to-[#FF6200] opacity-25"
        style="
          clip-path: polygon(
            73.6% 51.7%,
            91.7% 11.8%,
            100% 46.4%,
            97.4% 82.2%,
            92.5% 84.9%,
            75.7% 64%,
            55.3% 47.5%,
            46.5% 49.4%,
            45% 62.9%,
            50.3% 87.2%,
            21.3% 64.1%,
            0.1% 100%,
            5.4% 51.1%,
            21.4% 63.9%,
            58.9% 0.2%,
            73.6% 51.7%
          );
        "
      />
    </div>
  </div>
</template>

<style scoped>
.glass-effect-card {
  background-color: #92919129;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  backdrop-filter: blur(13px);
}
</style>
